// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"70":"635a44f9","260":"8ba43eb1","636":"6c2f4d1f"}[chunkId] + ".chunk.css";
};